export * from "./performanceViewerSceneExtension.pure";

import { RegisterPerformanceViewerSceneExtension } from "./performanceViewerSceneExtension.pure";
RegisterPerformanceViewerSceneExtension();
